'use client';

export { default } from './Link';
export { default as linkClasses } from './linkClasses';
export * from './linkClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Link/index.js
// module id = 859
// module chunks = 22